module.exports = __webpack_public_path__ + "static/media/profile2.c1e4057d.jpg";